import { FC } from "react";
import { TextSwitch } from "@landtechnologies/components";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { MapModes } from "../../../typings";

export interface MapModeProps {
  mapMode: MapModes;
  setMapMode: (mapMode: MapModes) => void;
}

export const MapMode: FC<MapModeProps> = ({ mapMode, setMapMode }) => {
  const { t } = useTranslation();

  return (
    <div className="atlas-flex atlas-gap-2 atlas-justify-between" data-testid="map-mode">
      <h4 className="atlas-text-sm atlas-font-medium atlas-my-auto">
        {t("comparables.map.sidebar.filters.mode.map.title")}
      </h4>
      <TextSwitch<MapModes>
        value={mapMode}
        name="mapMode"
        label={t("comparables.map.sidebar.filters.mode.map.title")}
        widthClass={"atlas-min-w-[200px]"}
        onChange={(v) => setMapMode(v === MapModes.HEATMAP ? MapModes.HEATMAP : MapModes.SCATTER)}
        options={[
          { label: t("comparables.map.sidebar.filters.mode.map.scatter"), value: MapModes.SCATTER },
          { label: t("comparables.map.sidebar.filters.mode.map.heatmap"), value: MapModes.HEATMAP },
        ]}
      />
    </div>
  );
};
